import React, { useEffect, useState } from 'react';
import { LinkedinIcon } from 'lucide-react';
import { getRandomFooterMessage } from '../utils/rantUtils';
import { APP_VERSION } from '../App';
export const Footer: React.FC = () => {
  const [message, setMessage] = useState<string>(getRandomFooterMessage());
  useEffect(() => {
    const interval = setInterval(() => {
      setMessage(getRandomFooterMessage());
    }, 10000);
    return () => clearInterval(interval);
  }, []);
  return <footer className="bg-background-light py-8 px-6 text-center border-t border-gray-800" data-id="element-44">
      <p className="text-text-secondary italic max-w-2xl mx-auto mb-8" data-id="element-45">
        {message}
      </p>
      <div className="max-w-4xl mx-auto my-10 px-4" data-id="element-46">
        <p className="text-text-secondary text-sm leading-relaxed mb-3" data-id="element-47">
          IBD Rant is an anonymous space for people with Inflammatory Bowel
          Disease to vent their frustrations. Share what pisses you off, vote on
          what resonates, and know you're not alone in this crappy journey.
        </p>
        <a href="https://www.linkedin.com/in/jaclyn-shumate-0383b14/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-text-secondary hover:text-primary transition-colors text-sm" data-id="element-48">
          <LinkedinIcon className="h-4 w-4" data-id="element-49" />
          Connect on LinkedIn
        </a>
      </div>
      <div className="mt-4 text-sm text-text-secondary" data-id="element-50">
        <p data-id="element-51">
          © {new Date().getFullYear()} IBD Rant - A cathartic space for IBD
          warriors
        </p>
        <p className="mt-2 text-xs opacity-50" data-id="element-52">v{APP_VERSION}</p>
      </div>
    </footer>;
};